import { styled } from '@mui/system'
import { Box, MenuItem, Select } from '@mui/material'

export const SelectWrapper = styled(Box)(
  ({ theme }) => `
  width:100%;
  display:flex;
  flex-direction:column;
`
)

export const SelectThemeV2Wrapper = styled(Box)(`
	& > label  {line-height:1; height:auto; padding:0; font-size:13px; color:#686867;}
	& > .selectWrap  {	
    height: 36px !important;
    padding: 0 0px;
    border-radius: 4px;
    border: 1px solid #E0E0DE;
    background: #FFF;
    line-height:1;
    position:relative;
  }
	& > .selectWrap .MuiInputBase-root { 
    box-shadow: none; 
    min-width:80px; 
    height:auto; 
    padding-left: 8px;
    // padding-right: 20px;
  }
	& > .selectWrap .selectPlaceholder { 
  margin-left: 0; color:#454545; opacity:1; font-size:13px; line-height:1; font-weight:400; white-space: nowrap; overflow: hidden;  text-overflow: ellipsis; padding-left: 8px;}
	& > .selectWrap .MuiSelect-icon { right: 5px; }
	& > .selectWrap fieldset { display: none; }
	& > .selectWrap .Mui-focused > div { background: transparent; }
	& > .selectWrap .MuiInputBase-root:before, 	& > .selectWrap .MuiInputBase-root:after { display: none; }
	& > .selectWrap .MuiSelect-select { padding:0; font-size: 13px; line-height: 37px; color:#454545; font-weight:400; position:relative; z-index:2; height:36px; overflow: hidden; text-overflow: ellipsis; padding-right:20px;}
  & > .selectWrap svg {position: absolute; top: 8px; right: 1px; z-index:1;}


`)

export const FormLabel = styled('label')(`
  font-style: normal;
  font-weight: 400; // 300;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  width:100%;
  padding-bottom:10px;
`)

export const FormError = styled(Box)(`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
`)

export const FormSelectWrap = styled(Box)(`
  position: relative;

  &.darkTheme {
    border-color: rgba(69, 69, 69, 0.5);
    & .MuiSelect-select { color: #454545; font-size: 14px;}

    & .selectPlaceholder { color: #686767; }
  }
`)

export const InputLabel = styled(Box)(
  (props) => `
  margin-left: 15px;
  margin-bottom: -30px;
  margin-top: 0;
  opacity: 50%;
  font-size: 12px;
  z-index: 0;
  position: absolute;
  width: fit-content;
  line-height: 40px;
  height: 100%;
  display: flex;
  align-items: center;
`
)

export const StyledMenuItem = styled(MenuItem)(
  (props) => `
  min-height: ${props.compact ? '42px' : 'auto'};
  flex-direction: ${props.compact && !props.single ? 'row-reverse' : 'row'};
  paddingLeft: ${props.compact ? '10px' : '20px'};
  font-size: ${props.compact ? '13px' : '16px'};
  white-space: normal;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
  & span {
    font-size: ${props.compact ? '12px' : '16px'};
  }
  &:hover , &.Mui-selected:hover , &.Mui-selected { 
    color: #095BBD; 
    background-color : unset !important;
  }
`
)

export const StyledSelect = styled(Select)(
  (props) => `
  background: transparent;
  font-size: ${props.compact ? '12px' : '16px'};
  height: ${props.compact ? '34px' : 'auto'};
  box-shadow: ${props.compact ? '0px 1px 2px rgba(16, 24, 40, 0.12)' : ''};
  & legend{
    width: ${props.compact ? '0' : 'auto'};
  }
  &.MuiOutlinedInput-root{
    &.Mui-disabled {
      background: #F7F7F9 !important;
    }
  }
  & img {
    margin-top: 3px;
    width: 12px;
    right: 13px;
  }

  & .dropdownArrow {
    margin: 0;
    padding: 0;
    position: absolute;
    right: 0;
    top: 8px;
  }
`
)
